/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import jsonSchemaDefaults from 'json-schema-defaults';

import { schema as Schema } from './pg-config.schema';
import { Config } from './pg-config.types';

export const defaults = (schema: typeof Schema): Config => jsonSchemaDefaults(schema);
